import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioAccommodationAddonEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioAccommodationAddonEntity
